<div style="position: relative" [id]="ContainerId">
  <div class="filter-container" [ngClass]="{'filter-container-open': FilterOpen}" (click)="openFilter()">
    <div class="placeholder-container" *ngIf="!SelectedOptions || SelectedOptions.length == 0">
      <img [src]="IconUrl" alt="">
      <p>{{PlaceholderFilter}}</p>
    </div>
    <div class="selected-text-container" *ngIf="SelectedOptions?.length && SelectedOptions.length > 0">
      <p *ngIf="Multiselect">{{SelectedOptions.length}} {{SelectedText}}</p>
      <p *ngIf="!Multiselect">{{SelectedOptions[0]}}</p>
      <img (click)="deleteFilter($event)" class="close-icon" src="../../../assets/icons/x.svg" alt="">
    </div>
    <img class="chevron-icon" [ngClass]="{'transform-rotation-180': FilterOpen}" src="/assets/icons/chevron-down.svg"
      alt="">
  </div>


  <div class="absolut-container" [style.width]="PopupWidth ? PopupWidth : '300px'" *ngIf="FilterOpen">
    <div class="no-option-container" *ngIf="!Options || Options.length == 0">
      {{NoOptionsText}}
    </div>
    <div *ngIf="Options && Options.length > 0">
      <div class="options-list-container">
        <div *ngFor="let option of Options; let i = index; let last = last">
          <div class="split" *ngIf="i != 0"></div>
          <div class="option-container" (click)="updateSelectedOption(option)">
            {{option}}<input type="radio" class="checkbox-square" [checked]="SelectedOptions.includes(option)" readonly>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>